export enum CommentType {
  USER = 1,
  SYSTEM
}
